export default __webpack_public_path__ + "assets/enterprise-three-one.3efa692c7523ca7ad0a23da76f7adbf1.png";